import { useEffect, useState } from 'react';

/**
 * Returns a value that lags behind the input by `delayMs`, resetting the
 * timer on every change. Useful for live-search inputs where we want to
 * avoid issuing a network request on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
